import React, { useLayoutEffect } from 'react';
import { useTheme } from '../../shell/surfaceContract';

/**
 * DR-9: CSS-only theme authority.
 * Sets data-theme attribute only. All token values come from foundation.css
 * via the [data-theme] attribute selector. No style.setProperty injection.
 */
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = theme.mode;
    root.style.colorScheme = theme.mode;
    root.classList.remove('dark');
  }, [theme.mode]);

  return <>{children}</>;
};
